<template>
  <v-row class="d-flex justify-center">
    <v-col cols="12">
      <section id="how-it-work">
        <div class="container">
          <div class="section-title mb-50">
            <h3 class="title-keyword">{{ $t("how_it_works") }}</h3>
            <div
              class="line"
              style="width: 100%; height: 10px; background: #249d82"
            ></div>
          </div>
          <!--          <img width="100%" src="/video/howitworks.gif" />-->
          <video
            src="/video/howitworks.mp4"
            muted
            autoplay
            loop
            playsinline
          ></video>
        </div>
      </section>
      <section id="use-case" class="mt-150">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="section-title justify-space-between">
                <h2 class="title-keyword">{{ $t("use_case") }}</h2>
                <div
                  class="line"
                  style="width: 100%; height: 10px; background: #249d82"
                ></div>
              </div>
              <!-- section title -->
            </div>
          </div>
        </div>
      </section>
      <section id="showcase" class="about-area pt-70">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div
                class="about-content mt-50 wow fadeInLeftBig"
                data-wow-duration="1s"
                data-wow-delay="0.5s"
              >
                <div class="section-title">
                  <div class="line"></div>
                  <h3
                    class="title-keyword"
                    v-html="$t('interactive_video_title')"
                  ></h3>
                </div>
                <!-- section title -->
                <p class="text">
                  {{ $t("interactive_video_des") }}
                </p>

                <a @click="nexToPageShowcase('2')" class="main-btn">{{
                  $t("examples")
                }}</a>
              </div>
              <!-- about content -->
            </div>
            <div class="col-lg-6">
              <div
                class="about-image text-center mt-50 wow fadeInRightBig"
                data-wow-duration="1s"
                data-wow-delay="0.5s"
              >
                <img src="images/about1.webp" alt="about" />
              </div>
              <!-- about image -->
            </div>
          </div>
          <!-- row -->
        </div>
        <!-- container -->
        <div class="about-shape-1">
          <img src="images/about-shape-1.svg" alt="shape" />
        </div>
      </section>
      <section class="about-area pt-70">
        <div class="about-shape-2">
          <img src="images/about-shape-2.svg" alt="shape" />
        </div>
        <div class="container">
          <div class="row">
            <div class="col-lg-6 order-lg-last">
              <div
                class="about-content mt-50 wow fadeInLeftBig"
                data-wow-duration="1s"
                data-wow-delay="0.5s"
              >
                <div class="section-title">
                  <div class="line"></div>
                  <h3 class="title-keyword">
                    {{ $t("contextual_advertising_title") }}
                  </h3>
                </div>
                <!-- section title -->
                <p class="text">
                  {{ $t("contextual_advertising_des") }}
                </p>
                <a @click="nexToPageShowcase('4')" class="main-btn">{{
                  $t("examples")
                }}</a>
              </div>
              <!-- about content -->
            </div>
            <div class="col-lg-6 order-lg-first">
              <div
                class="about-image text-center mt-50 wow fadeInRightBig"
                data-wow-duration="1s"
                data-wow-delay="0.5s"
              >
                <img src="images/about2.webp" alt="about" />
              </div>
              <!-- about image -->
            </div>
          </div>
          <!-- row -->
        </div>
        <!-- container -->
      </section>
      <section class="about-area pt-70">
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div
                class="about-content mt-50 wow fadeInLeftBig"
                data-wow-duration="1s"
                data-wow-delay="0.5s"
              >
                <div class="section-title">
                  <div class="line"></div>
                  <h3 class="title-keyword" v-html="$t('live_title')"></h3>
                </div>
                <!-- section title -->
                <p class="text">
                  {{ $t("live_des") }}
                </p>
                <v-dialog v-model="dialog" width="500px">
                  <template v-slot:activator="{ on, attrs }">
                    <a v-bind="attrs" v-on="on" class="main-btn">{{
                      $t("contact_us")
                    }}</a>
                  </template>
                  <form-request-live @close="dialog = false" />
                </v-dialog>
              </div>
              <!-- about content -->
            </div>
            <div class="col-lg-6">
              <div
                class="about-image text-center mt-50 wow fadeInRightBig"
                data-wow-duration="1s"
                data-wow-delay="0.5s"
              >
                <img src="images/about3.webp" alt="about" />
              </div>
              <!-- about image -->
            </div>
          </div>
          <!-- row -->
        </div>
        <!-- container -->
        <div class="about-shape-1">
          <img src="images/about-shape-1.svg" alt="shape" />
        </div>
      </section>
      <section id="tech-specs" class="services-area pb-200 pt-120">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="section-title pb-40">
                <h3 class="title-keyword">{{ $t("tech_specs") }}</h3>
                <div
                  class="line"
                  style="width: 100%; height: 10px; background: #249d82"
                ></div>
              </div>
              <!-- section title -->
            </div>
          </div>
          <!-- row -->
          <div class="row justify-content-center">
            <div
              class="col-lg-4 col-md-7 col-sm-8"
              v-for="(model, idx) in modelsAi"
              :key="idx"
            >
              <div
                class="single-services text-center mt-30 wow fadeIn"
                data-wow-duration="1s"
                data-wow-delay="0.2s"
              >
                <div class="services-icon">
                  <img
                    class="shape"
                    src="/images/services-shape.svg"
                    alt="shape"
                  />
                  <img
                    class="shape-1"
                    src="/images/services-shape-1.svg"
                    alt="shape"
                  />
                  <i>
                    <img :src="model.icon" />
                  </i>
                </div>
                <div class="services-content mt-30">
                  <h4
                    class="services-title"
                    @click="nexToPageTechSpecs(model.url)"
                  >
                    <a @click="nexToPageTechSpecs(model.url)">{{
                      $t(model.name)
                    }}</a>
                  </h4>
                  <p class="text">
                    {{ $t(model.des) }}
                  </p>
                  <a class="more" @click="nexToPageTechSpecs(model.url)"
                    >{{ $t("learn_more") }}<i class="lni-chevron-right"></i
                  ></a>
                </div>
              </div>
              <!-- single services -->
            </div>
          </div>
          <!-- row -->
        </div>
        <!-- container -->
      </section>
      <section id="my-team" class="services-area pb-200 pt-120">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="section-title pb-40">
                <h3 class="title-keyword">{{ $t("my_team") }}</h3>
                <div
                  class="line"
                  style="width: 100%; height: 10px; background: #249d82"
                ></div>
              </div>
              <!-- section title -->
            </div>
          </div>
          <!-- row -->
          <div class="row justify-content-center">
            <meet-out-team />
          </div>
          <!-- row -->
        </div>
        <!-- container -->
      </section>
    </v-col>
  </v-row>
</template>

<script>
import { call } from "vuex-pathify";
import { mdiClose } from "@mdi/js";
import FormRequestLive from "./components/FormRequestLive";
import MeetOutTeam from "./components/MeetOurTeam";

export default {
  name: "index",
  components: { FormRequestLive, MeetOutTeam },
  data() {
    return {
      dialog: false,
      modelsAi: [
        {
          name: "celeb_title",
          icon: "images/models/celeb-icon.svg",
          des: "celeb_short_des",
          url: "celeb_title",
        },
        {
          name: "emotion_title",
          icon: "images/models/emotion-icon.svg",
          des: "emotion_short_des",
          url: "emotion_title",
        },
        {
          name: "action_title",
          icon: "images/models/action-icon.svg",
          des: "action_short_des",
          url: "action_title",
        },
        {
          name: "scene_title",
          icon: "images/models/scene-icon.svg",
          des: "scene_short_des",
          url: "scene_title",
        },
        {
          name: "cmn_obj_title",
          icon: "images/models/cmn-obj-icon.svg",
          des: "cmn_obj_short_des",
          url: "cmn_obj_title",
        },
        {
          name: "poster_candidate_title",
          icon: "images/models/poster-icon.svg",
          des: "poster_candidate_short_des",
          url: "",
        },
        {
          name: "branding_title",
          icon: "images/models/branding-icon.svg",
          des: "branding_short_des",
          url: "branding_title",
        },
        {
          name: "color_title",
          icon: "images/models/color-icon.svg",
          des: "color_short_des",
          url: "color_title",
        },
        {
          name: "age_gender_title",
          icon: "images/models/age-gender-icon.svg",
          des: "age_gender_short_des",
          url: "age_gender_title",
        },
      ],
      mdiClose: mdiClose,
    };
  },
  methods: {
    changeLocale: call("app/changeLocale"),
    nexToPageTechSpecs(sectionId) {
      this.$router.push({ name: "TechSpecs", hash: `#${sectionId}` });
    },
    nexToPageShowcase(typeShowCase) {
      this.$router.push({
        name: "ShowCase",
        query: { typeShowCase: typeShowCase },
      });
    },
  },
};
</script>
<style scoped></style>
